var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:{
    'marketo-root': _vm.isAssetRoot(this),
    'marketo-folder': _vm.isFolder(this),
    'marketo-workspace': _vm.isAssetWorkspace(this),
    'main': false,
    'active': _vm.active,
    'marketo-empty': _vm.isAssetEmptyFolder(this),
    }},[_c('a',{class:{
        'marketo-item': true,
        'main': false,
        'marketo-root': _vm.isAssetRoot(this),
        'marketo-folder': _vm.isFolder(this),
        'marketo-empty': _vm.isAssetEmptyFolder(this),
        'marketo-workspace': _vm.isAssetWorkspace(this),
        'marketo-empty-workspace': _vm.isEmptyWorkspace(this),

        },attrs:{"href":"javascript:"},on:{"click":_vm.childClick}},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_vm._l((_vm.children),function(child){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}]},[(child.type == 'folder')?_c('marketo-child',{attrs:{"tree":child.children,"workspace":child.workspace,"parent_key":child.parent_key,"id_key":child.key,"parent_active":_vm.active,"folderType":child.folderType,"idType":child.idType,"parent_id":_vm.folder_id,"parent_path":_vm.path,"folder_id":child.id,"type":child.type,"name":child.name}}):_vm._e(),_vm._v(" "),(child.type !== 'folder')?_c('div',{class:{
            'marketo-email' : _vm.isAssetEmail(child),
            'marketo-email-template' : _vm.isAssetEmailTemplate(child),
            'marketo-landing-page' : _vm.isAssetLandingPage(child),
            'marketo-landing-page-template' : _vm.isAssetLandingPageTemplate(child),
            'marketo-snippet' : _vm.isAssetSnippet(child),

                            'marketo-item': true,
                            'main': false,
                            'marketo-file': true,
                            'marketo-selected': _vm.isAssetSelected(child),
                            'marketo-found': _vm.isAssetFound(child)
                        },on:{"click":function($event){return _vm.selectFile(child)}}},[_vm._v("\n                "+_vm._s(child.name)+"\n            ")]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.children.length === 0),expression:"children.length === 0"}],staticClass:"marketo-item"},[_c('em',[_vm._v("(empty folder)")])])],1)})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }